import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';

export const userSelector = (state: AppState) => state.user;

export const usernameSelector = createSelector(userSelector, (user) => {
  const usernameIndex =
    (user.domain && user.domain.indexOf('precision-planting')) ?? -1;
  return (
    (user.domain &&
      usernameIndex !== -1 &&
      user.username &&
      user.username[usernameIndex]) ||
    user.email
  );
});

export const getUserPreferences = createSelector(
  [userSelector],
  (user) => user.preferences ?? {}
)
